import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/PricingPage.module.css'; 
import videoBackground from '../styles/background.mp4';

const plans = [
  
  {
    name: "Basic",
    priceMonthly: "FREE",
    
    summary: "Essential and Efficient Fleet Management for Small to Mid-Sized Operations",
   details: `
<strong>BASIC Plan</strong> – Simplified Operations for Small Trucking Businesses<br/><br/>
The BASIC plan is ideal for small companies that need essential tools to manage operations.<br/>
It allows you to track loads, manage up to <strong>5 drivers</strong> and <strong>5 trucks</strong>, and generate basic payroll reports.<br/><br/>

<strong>Core Features:</strong><br/>
- Add, edit, and manage loads<br/>
- Add up to 1 driver and 1 truck<br/>
- Generate and edit Driver Pays for drivers and trucks<br/><br/>

<strong>Payroll:</strong><br/>
- Create payrolls based on completed loads<br/><br/>

<strong>Designed For:</strong><br/>
Small businesses that need a simple and cost-effective system for managing their core trucking needs.
`


  },
  {
    name: "Standard",
    priceMonthly: "$9.99 and 30 days TEST",
    priceAnnual: "$9.99 and 3 months free",
    summary: "Advanced Fleet & Financial Management for Growing Trucking Businesses",
 details: `
<strong>STANDARD Plan</strong> – Enhanced Operations with Fuel Reporting and Branding<br/><br/>
Everything from BASIC, plus expanded limits and advanced reporting tools.<br/><br/>

<strong>Fleet Expansion:</strong><br/>
- Add up to 3 drivers and 3 trucks<br/>
- Add/edit loads and assign assets<br/>
- Upload your company logo to personalize Driver Pays<br/><br/>

<strong>Fuel Management:</strong><br/>
- Add and manage Fuel Reports<br/>
- Export Fuel Reports to PDF or Excel<br/>
- Add manual IFTA data and generate official reports<br/><br/>

<strong>Payroll:</strong><br/>
- Fully branded Driver Pays with your company details<br/><br/>
<strong> Other:</strong><br/>
Each additional driver: $3.49/month<br/><br/>
<strong> Designed For:</strong><br/>
Growing companies that need control over fuel costs and customized payroll branding.
`


  },
  {
    name: "Premium",
    priceMonthly: "$29.99 and 30 days TEST",
    priceAnnual: "$29.99 and 3 months free",
    summary: "Advanced Automation & Comprehensive Financial Control",
    popular: true,
   details: `
<strong>PREMIUM Plan</strong> – Full Financial Automation & Invoicing<br/><br/>
Includes all STANDARD features, plus advanced billing, payroll, and company-wide dashboards.<br/><br/>

<strong> Fleet Capacity:</strong><br/>
- Up to 5 drivers and 5 trucks<br/><br/>

<strong> Overview Dashboard:</strong><br/>
- Monitor KPIs like revenue, expenses, and load completion<br/><br/>

<strong> Invoicing:</strong><br/>
- Generate client invoices and export them as PDFs<br/>
- Send invoices via email directly from the system<br/><br/>

<strong> Accounts Payable:</strong><br/>
- Archive and manage Received Invoices and outgoing payments<br/><br/>

<strong> Employee Payroll:</strong><br/>
- Add employees, assign roles<br/>
- Track salaries and payroll status<br/><br/>
<strong> Other:</strong><br/>
Each additional driver: $3.49/month<br/><br/>
<strong> Designed For:</strong><br/>
Businesses ready to automate billing, track finances, and manage teams in one unified platform.
`


  },
 

  {
    name: "Ultimate",
    priceMonthly: "$99,99 and 30 days TEST",
    priceAnnual: "$99,99 and 3 months free",  
  summary: "The Most Powerful, Automated & Scalable Solution for Ultimate-Level Trucking Businesses",
 
    
  details: `
<strong>ULTIMATE Plan</strong> – Full Ultimate Trucking Management<br/><br/>
Everything from PREMIUM, plus real-time tracking, mobile app support, AI automation, and accounting tools.<br/><br/>

<strong>Fleet Expansion:</strong><br/>
- Add up to 7 drivers and 7 trucks<br/><br/>

<strong> Dashboards:</strong><br/>
- Separate dashboards for Drivers, Trucks, and Loads<br/>
- See which dispatcher assigned a load, who’s moving it, and financial data<br/><br/>

<strong> Accounting Manager & Factoring:</strong><br/>
- View all open invoices<br/>
- Upload BOL, RC, and other documents<br/>
- Email invoice packages directly to factoring companies<br/>
- Track sent/unpaid submissions<br/><br/>

<strong> Trucks & Trailers:</strong><br/>
- Track insurance, leasing, maintenance, and taxes<br/><br/>

<strong> Balance Sheet:</strong><br/>
- Visualize every dollar going in and out of your business<br/><br/>

<strong> Auto-Fill Load Info with AI:</strong><br/>
- Upload RCs and auto-complete fields using AI<br/>
- Manually verify or correct values easily<br/><br/>

<strong> Mobile Driver App:</strong><br/>
- Real-time location sharing<br/>
- Secure broker links with expiration<br/>
- Built-in scanner for PDFs<br/>
- Chat with web dispatcher (text, files, images)<br/><br/>

<strong> 24/7  Support (Phone) </strong><br/><br/>

<strong> Other:</strong><br/>
Each additional driver: $3.49/month<br/><br/>

<strong>Designed For:</strong><br/>
Large fleets that need automation, tracking, factoring integration, and mobile connectivity at scale.
`

  },
    {
    name: "Enterprise",
    priceMonthly: "$499,99 and 30 days TEST",
    priceAnnual: "$499,99 and 3 months free",
    summary: "Full-Scale Enterprise Management with Maximum Features and Support",
   
    details: `
<strong>ENTERPRISE Plan</strong> – Scalable Solutions for Large Fleets and Corporations<br/><br/>
The ENTERPRISE plan is tailored for companies with large operations, complex workflows, and the need for maximum automation and support.<br/><br/>

<strong>Fleet Capacity:</strong><br/>
- Manage up to 100 drivers and 100 trucks<br/>
- Add unlimited loads with AI-powered data extraction<br/><br/>

<strong>Enterprise Dashboards:</strong><br/>
- Multi-level dashboards for Drivers, Trucks, Loads, and Dispatchers<br/>
- Advanced KPIs, financial projections, and AI-driven strategy recommendations<br/><br/>

<strong>Accounting & Payroll:</strong><br/>
- Full accounting manager with factoring support<br/>
- Employee payroll for drivers, dispatchers, and office staff<br/>
- Balance sheet with real-time company cashflow<br/><br/>

<strong>Driver Mobile App:</strong><br/>
- Real-time GPS tracking and messaging<br/>
- Document scanning and instant upload to dispatcher<br/><br/>

<strong>Security & Control:</strong><br/>
- Custom access levels for staff and departments<br/>
- Encrypted document management<br/><br/>

<strong>Premium Support:</strong><br/>
- Dedicated account manager<br/>
- 24/7 Enterprise Phone Support<br/><br/>

<strong>Designed For:</strong><br/>
Large corporations that require complete visibility, scalability, and continuous support for every aspect of their trucking business.
`
  },


  {
    name: "Custom",
    priceMonthly: "Custom Pricing",
    priceAnnual: "Tailored to Your Needs",
    summary: "A fully customizable plan for enterprises with unique needs.",
  details: `
<strong>Custom Plan</strong> – Tailored to Fit Enterprise-Scale Trucking Needs<br/><br/>
The Custom Plan is built for companies with unique workflows, large-scale fleets, and specialized operational needs.<br/>
Work directly with our team to configure a plan that delivers exactly what your business requires.<br/><br/>

<strong>Customizable Features Include:</strong><br/>
- Unlimited loads, drivers, and trucks<br/>
- AI-powered fleet optimization<br/>
- Advanced accounting & payroll workflows<br/>
- Personalized integrations with your tech stack<br/><br/>

<strong>Pricing:</strong><br/>
- Based on selected features and business size<br/><br/>

<strong>Premium Support:</strong><br/>
- Dedicated account manager<br/>
- Priority 24/7 support<br/>
- Personalized onboarding and training<br/><br/>

<strong>Built For:</strong><br/>
Enterprises that need full flexibility and high scalability across every department.
`

  }
];

const PricingPage = () => {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState(null);
const [isPricingMenuOpen, setIsPricingMenuOpen] = useState(false);
 const [alert, setAlert] = useState(null);
   const handleComingSoonClick = (planName) => {
    setAlert({
      title: `${planName} Plan Coming Soon `,
      message: `The ${planName} plan is not ready yet. Until then, you're invited to use another plan. Once it's available, you'll receive a personalized offer based on your current subscription.`,
    });
    setTimeout(() => setAlert(null), 6000);
  };
  return (
    <div className={styles.pricingPageContainer}>
       <video className={styles.pricingPageVideoBackground} autoPlay loop muted>
             <source src={videoBackground} type="video/mp4" />
             Your browser does not support the video tag.
           </video>

  <header className={styles.pricingPageheader}>
      <div onClick={() => navigate('/')} className={styles.pricingPagelogo}>
        Full Trucking Service
      </div>

      {/* Buton meniu hamburger */}
      <div className={styles.hamburgerPricing} onClick={() => setIsPricingMenuOpen(!isPricingMenuOpen)}>
        ☰ {/* Poți pune un icon dacă vrei */}
      </div>

      <nav className={`${styles.navMenuPricing} ${isPricingMenuOpen ? styles.activePricing : ''}`}>
        <ul>
          <li onClick={() => navigate('/about')}>About Us</li>
          <li onClick={() => navigate('/services')}>Services</li>
          <li onClick={() => navigate('/contact')}>Contact</li>
          <li onClick={() => navigate('/pricing')}>Register</li>
        </ul>
      </nav>
    </header>
<h1 className={styles.pricingPagetitle}>Choose Your Plan</h1>

<div className={styles.pricingPageplansContainer}>
  {plans.map((plan, index) => (
    <div
      key={index}
      className={`${styles.pricingPageplanCard} ${
        plan.popular ? styles.popularPlan : ""
      }`}
    >
      {plan.popular && <div className={styles.popularBadge}>Most Popular</div>}

      {plan.comingSoon && (
        <div className={styles.comingSoonX}>
          <span className={`${styles.comingSoonBanner} ${styles.left}`}>COMING SOON</span>
          <span className={`${styles.comingSoonBanner} ${styles.right}`}>COMING SOON</span>
        </div>
      )}

      <h2>{plan.name}</h2>
      <p>{plan.summary}</p>
      <div className={styles.pricingPageprice}>Monthly: {plan.priceMonthly}</div>
      <div className={styles.pricingPagepriceAnnual}>Annual: {plan.priceAnnual}</div>

<button
  onClick={() => {
    if (plan.name === "Custom") {
      window.location.href = "https://full-trucking-service.com/contact";
    } else if (plan.comingSoon) {
      handleComingSoonClick(plan.name);
    } else {
      navigate("/register", { state: { plan: plan.name } });
    }
  }}
  className={plan.comingSoon ? styles.disabledButton : ""}
>
  Select {plan.name}
</button>


<button
  onClick={() =>
    plan.comingSoon ? handleComingSoonClick(plan.name) : setSelectedPlan(plan)
  }
  className={plan.comingSoon ? styles.disabledButton : ""}
>
  See More
</button>

    </div>
  ))}
  {alert && (
  <div className={styles.alertBox}>
    <div className={styles.alertTitle}>{alert.title}</div>
    <div className={styles.alertMessage}>{alert.message}</div>
  </div>
)}

</div>


      {/* Modal for detailed plan info */}
      {selectedPlan && (
        <div className={styles.pricingPagefullScreenModal}>
          <div className={styles.pricingPagemodalContent}>
          <button className={styles.pricingPagecloseButton} onClick={() => setSelectedPlan(null)}>✖</button>
            <h2>{selectedPlan.name} Plan</h2>
            <p dangerouslySetInnerHTML={{ __html: selectedPlan.details.replace(/\n/g, '<br/>') }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingPage;
